export default __webpack_public_path__ + "static/media/vegard.d02565ce.jpg";